// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__TzH6n","colMaxWidth":"Table_colMaxWidth__23PZC"};